<template>
  <div class="d-flex flex-column align-items-center h-100 justify-content-center">
      <h1 class="text-primary" style="font-size: 50px">Accès refusé</h1>
      <p class="mt-4">Votre compte ne vous permet pas d'avoir accès à cette ressource</p>
      <p>
        Oups ! La page que vous cherchez n'est pas accessible par votre compte, si vous pensez que c'est une erreur veuillez vous rapporcher de votre direction.
      </p>
      <button
          @click="gobackHome"
          class="btn bt-challenges btn-secondary"
      >
        Retour à l’accueil
      </button>
  </div>
</template>

<script>

import {router} from "@/router";
import ApiAuthenticationService from "@/services/ApiAuthenticationService";

export default {
  name:"no_access",
    components:{
    },   
  data () {
    return {
    }
  },
  methods : {
    gobackHome() {
      ApiAuthenticationService.reloadUser();
      router.push('/')
    }
  }
};
</script>
